import React from 'react'
import styled from 'styled-components'
import { breakpoint, getColor } from '../../shared/theme'
import ContentContainer from '../contentContainer'
import Copy from '../../elements/typography/sectionCopy'
import { getImage } from '../../utils/getData'

const SectionWrapper = styled.section`
	padding: 50px 0 0px;

	@media ${breakpoint('tablet')} {
		padding: 75px 0 0px;
	}

	@media ${breakpoint('laptop')} {
		padding: 102px 0 0px;
	}
`

const SectionBody = styled.div``

const RepeaterItem = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-bottom: 37px;
	width: 100%;

	@media ${breakpoint('tablet')} {
		flex-direction: ${(props) => (props.index === 0 ? 'row-reverse' : 'row')};
		margin-bottom: 54px;
		justify-content: space-between;
		align-items: center;
	}
`

const CopyWrapper = styled.div`
	color: ${getColor('black')};
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 30px;
	margin: 0 auto 30px auto;
	text-align: center;

	@media ${breakpoint('tablet')} {
		width: ${(props) => (props.index === 0 ? '33.6%' : '35%')};
		margin: 0;
		align-items: flex-start;
		text-align: left;
	}
`

const TitleWrapper = styled.div`
	margin-bottom: 20px;

	@media ${breakpoint('tablet')} {
		margin-bottom: 22px;
	}
`

const Title = styled.h3`
	font-size: 20px;
	font-weight: 700;
	line-height: 24px;
	margin-bottom: 0px;

	@media ${breakpoint('tablet')} {
		font-size: 40px;
		line-height: 48px;
		font-weight: 800;
	}
`

const ImageWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;

	@media ${breakpoint('tablet')} {
		width: 60%;
	}
`

const Image = styled.img`
	width: 100%;
	height: auto;
	max-width: 100%;

	@media ${breakpoint('tablet')} {
		max-width: 650px;
	}
`

const ImageWrapperPortrait = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;

	@media ${breakpoint('tablet')} {
		width: 46.1%;
		margin-right: 40px;
	}
`

const ImagePortrait = styled.img`
	width: auto;
	height: 100%;
	max-width: 100%;

	@media ${breakpoint('tablet')} {
		max-height: 650px;
	}
`

export const Illustrations = ({ repeater }) => {
	if (!repeater?.length) return null

	return (
		<SectionWrapper>
			<ContentContainer>
				<SectionBody>
					{repeater &&
						repeater.map((content, index) => {
							let headingArray
							let headingStart
							let headingEnd

							if (content.heading) {
								headingArray = content.heading.split(' ')
								headingStart = headingArray.slice(0, 3).join(' ')
								headingEnd = headingArray.slice(3).join(' ')
							}
							return (
								<RepeaterItem key={index} index={index}>
									<CopyWrapper index={index}>
										<TitleWrapper>
											<Title>{headingStart && headingStart}</Title>
											<Title>{headingEnd && headingEnd}</Title>
										</TitleWrapper>
										<Copy
											styles={{
												color: '#000',
												marginBottom: '0',
											}}
										>
											{content.copy && content.copy}
										</Copy>
									</CopyWrapper>
									{index === 0 ? (
										<ImageWrapper>
											<Image
												src={getImage(content.image)}
												alt={content.image?.altText}
											/>
										</ImageWrapper>
									) : (
										<ImageWrapperPortrait>
											<ImagePortrait
												src={getImage(content.image)}
												alt={content.image?.altText}
											/>
										</ImageWrapperPortrait>
									)}
								</RepeaterItem>
							)
						})}
				</SectionBody>
			</ContentContainer>
		</SectionWrapper>
	)
}

export default Illustrations
